module.exports = __webpack_public_path__ + "img/zhishidian.800ca610.png";